module.exports = __webpack_public_path__ + "static/media/2001.00d47bf3.svg";